import './CashbackTermsAndConditions.scss'

import React from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import { acknowledgeTermsConditions } from 'broker/redux/account'

class CashbackTermsAndConditions extends React.Component {
  constructor(props) {
    super(props)
  }

  handleAcceptTermsAndConditions = () => {
    const { dispatch } = this.props
    dispatch(acknowledgeTermsConditions())
  }

  render() {
    return (
      <div className="CashbackTermsAndConditions">
        <Row>
          <Col xs={2}/>
          <Col xs={2}>
            <div className="terms-conditions-icon"/>
          </Col>
          <Col xs={5}>
            <div className="terms-conditions-content">
              <h2>We've updated our Terms and Conditions</h2>
              <p>
                We've updated our Broker Terms and Conditions to provide our partners with better service.
                These updates are effective April 1, 2019.
                You can view the latest version <a href="/terms" target="_blank">here</a>.
              </p>
            </div>

            <Button variant="primary" onClick={this.handleAcceptTermsAndConditions}>Continue</Button>
          </Col>
        </Row>
      </div>
    )
  }
}

export default CashbackTermsAndConditions
